<script>
  import { activeClass, exactClass, link } from "../../../../../core";
  import type { ITreeNavigationItem } from "./List.svelte";

  export let children: ITreeNavigationItem[];
</script>

<div class="sublevel">
  {#each children || [] as { url, title, children }}
    <a
      href={url}
      class="sublevel-link"
      use:link
      use:exactClass={"active-sublevel-exact"}
      use:activeClass={"active-sublevel"}
      on:click
    >
      <div class="item">
        {title}
      </div>
    </a>

    {#if children.length}
      <svelte:self {children} on:click />
    {/if}
  {/each}
</div>

<style lang="scss">
  .sublevel {
    @include small;
    display: none;
    padding-left: 14px;
    padding-top: 10px;
    font-weight: 400;

    :global(.active-sublevel + .sublevel) {
      display: block;
    }

    :global(.active-sublevel-exact) {
      position: relative;
      font-weight: 900;
      padding-left: 12px;

      &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 4px;
        height: 13px;
        width: 4px;
        background: #2e969b;
      }
    }
  }

  .sublevel-link {
    display: block;
    margin-bottom: 5px;
    color: $text-reverse-color;
    text-decoration: none;
  }

  .item {
    position: relative;
  }
</style>
